export default function AboutStats() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-secondary-50">
      <div className="flex flex-col lg:flex-row gap-12 lg:gap-24">
        {/* Left Label */}
        <div className="lg:w-1/4 flex-shrink-0">
          <p className="text-foreground-400 text-xs md:text-sm font-medium tracking-widest uppercase">
            Why GTBuy Sheet
          </p>
        </div>

        {/* Right Content */}
        <div className="lg:w-3/4">
          <p className="text-foreground-800 text-lg md:text-2xl font-medium leading-relaxed max-w-2xl">
            GTBuy Sheet is the gateway to <strong>kaspreadsheet.com</strong> &mdash; the most comprehensive
            spreadsheet shopping platform for streetwear, sneakers, and lifestyle products.
            We track thousands of verified items across 14 curated categories, updated weekly
            so you never miss a fresh drop. Whether you are hunting for limited sneakers,
            trending hoodies, or hidden accessory gems, our spreadsheet-based system gives you
            organized, filterable access to everything in one place.
          </p>

          {/* Stats Grid */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            <div>
              <p className="font-heading text-5xl md:text-6xl font-bold text-foreground-900">
                5,000<span className="text-accent-500">+</span>
              </p>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 font-medium">
                Verified Items
              </p>
            </div>
            <div>
              <p className="font-heading text-5xl md:text-6xl font-bold text-foreground-900">
                99<span className="text-accent-500">%</span>
              </p>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 font-medium">
                Update Accuracy
              </p>
            </div>
            <div>
              <p className="font-heading text-5xl md:text-6xl font-bold text-foreground-900">
                14<span className="text-accent-500">+</span>
              </p>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 font-medium">
                Product Categories
              </p>
            </div>
            <div>
              <p className="font-heading text-5xl md:text-6xl font-bold text-foreground-900">
                Weekly
              </p>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 font-medium">
                Fresh Drops
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}